function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useIsomorphicLayoutEffect } from "ahooks";
import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import classnames from "classnames";
import { mergeProps } from "../../utils/mergeProps";
import { usePropsValue } from "../../utils/use-props-value";
var classPrefix = "tc-textArea";
var TextArea = /*#__PURE__*/forwardRef(function (p, ref) {
  var _classnames;
  var props = mergeProps(TextArea.defaultProps, p);
  var style = props.style,
    className = props.className,
    autoComplete = props.autoComplete,
    autoFocus = props.autoFocus,
    autoSize = props.autoSize,
    disabled = props.disabled,
    id = props.id,
    border = props.border,
    maxLength = props.maxLength,
    name = props.name,
    onBlur = props.onBlur,
    onClick = props.onClick,
    onCompositionEnd = props.onCompositionEnd,
    onCompositionStart = props.onCompositionStart,
    onFocus = props.onFocus,
    placeholder = props.placeholder,
    readOnly = props.readOnly,
    rows = props.rows,
    showCount = props.showCount;
  var _usePropsValue = usePropsValue(Object.assign(Object.assign({}, props), {
      value: props.value === null ? "" : props.value
    })),
    _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
    value = _usePropsValue2[0],
    setValue = _usePropsValue2[1];
  var nativeTextAreaRef = useRef(null);
  var compositingRef = useRef(false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  // 字体计数
  var count;
  useImperativeHandle(ref, function () {
    return {
      clear: function clear() {
        setValue("");
      },
      focus: function focus() {
        var _a;
        (_a = nativeTextAreaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      },
      blur: function blur() {
        var _a;
        (_a = nativeTextAreaRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      },
      get nativeElement() {
        return nativeTextAreaRef.current;
      }
    };
  });
  useIsomorphicLayoutEffect(function () {
    if (!autoSize) return;
    var textArea = nativeTextAreaRef.current;
    if (!textArea) return;
    textArea.style.height = "auto";
    var height = textArea.scrollHeight;
    if (_typeof(autoSize) === "object") {
      var computedStyle = window.getComputedStyle(textArea);
      var lineHeight = parseFloat(computedStyle.lineHeight);
      if (autoSize.minRows) {
        height = Math.max(height, autoSize.minRows * lineHeight);
      }
      if (autoSize.maxRows) {
        height = Math.min(height, autoSize.maxRows * lineHeight);
      }
    }
    textArea.style.height = "".concat(height, "px");
  }, [value, autoSize]);
  function handleCompositionStart(e) {
    compositingRef.current = true;
    onCompositionStart === null || onCompositionStart === void 0 ? void 0 : onCompositionStart(e);
  }
  function handleCompositionEnd(e) {
    compositingRef.current = false;
    if (maxLength) {
      var v = e.target.value;
      setValue(_toConsumableArray(v).slice(0, maxLength).join(""));
    }
    onCompositionEnd === null || onCompositionEnd === void 0 ? void 0 : onCompositionEnd(e);
  }
  function handleClick(e) {
    if (readOnly || disabled) return;
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  }
  function handleChange(e) {
    var v = e.target.value;
    if (maxLength && !compositingRef.current) {
      v = _toConsumableArray(v).slice(0, maxLength).join("");
    }
    setValue(v);
  }
  function handleFocus(e) {
    setActive(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  }
  function handleBlur(e) {
    setActive(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  }
  /** 样式相关 */
  var textAreaCls = classnames("".concat(classPrefix), className, (_classnames = {}, _defineProperty(_classnames, "".concat(classPrefix, "--border"), border), _defineProperty(_classnames, "".concat(classPrefix, "--active"), active), _classnames));
  var textAreaElementCls = classnames("".concat(classPrefix, "-element"));
  var countCls = classnames("".concat(classPrefix, "-count"));
  var countActiveCls = classnames("".concat(classPrefix, "-count--active"));
  var valueLength = _toConsumableArray(value).length;
  if (typeof showCount === "function") {
    count = showCount(valueLength, maxLength);
  } else if (showCount) {
    count = /*#__PURE__*/React.createElement("div", {
      className: countCls
    }, maxLength === undefined ? /*#__PURE__*/React.createElement("span", {
      className: countActiveCls
    }, valueLength) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: countActiveCls
    }, valueLength), "/", maxLength));
  }
  var renderTextArea = function renderTextArea() {
    return /*#__PURE__*/React.createElement("textarea", {
      id: id,
      name: name,
      className: textAreaElementCls,
      ref: nativeTextAreaRef,
      value: value,
      rows: rows,
      placeholder: placeholder,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      disabled: disabled,
      readOnly: readOnly,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onClick: handleClick,
      onChange: handleChange,
      onCompositionStart: handleCompositionStart,
      onCompositionEnd: handleCompositionEnd
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: textAreaCls
  }, renderTextArea(), count);
});
TextArea.defaultProps = {
  defaultValue: "",
  autoComplete: "off",
  autoFocus: false,
  disabled: false,
  readOnly: false,
  rows: 3,
  showCount: false,
  autoSize: false,
  border: true
};
export default TextArea;